fx.ns("desktop.common", class CreationEditor extends fx.Component {
    
	constructor(data)
	{
		super(data);
	}

    // TO override
    get mediaTabs()
    {
        return null;
    }

    // TO override
    get board()
    {
        return null;
    }

    // TO override
    labelFunction()
    {
        return "";
    }

	contextMenu(e)
	{
        return [];
	}

	create()
	{
		super.create();

        if (this.mediaTabs)
            this.addChild(this.mediaTabs, {top:0,left:0,width:340,height:"100%"});

        if (this.board)
            this.addChild(this.board, {top:0,left:340,width:"100%",height:"100%"});

		// only the print editor (the one CreationEditor) shows the upload around the order button
		this.topBar = new desktop.common.actionbar.TopBar( this.data.creation, {uploadProgress : true});
		this.addChild(this.topBar,  {top:20,right:25,width:100});

		this.actionBar = new desktop.common.actionbar.ActionBar( this.data);
		this.addChild(this.actionBar,  {top:"center",right:25,width:70});

		this.topNotifications = new desktop.common.TopNotifications(this.data);
		this.topNotifications.visibleAtStart = false;
		this.addChild(this.topNotifications, {top : 10, right : 25});

		this.dragger = new desktop.common.behaviour.ComponentDragger( this.data, this );
		
        this.productLabel = new desktop.common.ProductLabel(this.data, this.labelFunction.bind(this));
        //this.productLabel.effect = "scroll";
        //this.productLabel.visibleAtStart = false;

        this.addChild( this.productLabel, { top : 25, height : 50, left:340,width:"100%"} );
	}

	onDisplayUpdated()
    {
		if (this.productLabel)
        {
            //this.productLabel.viewport({ width : this.board.realWidth - this.topBar.realWidth - this.topBar.right(), height : 50, top : 25, left : this.board.left()});
            //this.productLabel.show();
        }
    }

	onReady()
	{
		super.onReady();

        if (this.mediaTabs && this.board)
			this.mediaTabs.currentArea = this.board.currentArea;

        if (this.board)
            this.on("scrolled", this._onScroll, this.board);

		this.on("currentAreaChanged", this.onCurrentAreaChanged, this.board);
		this.on("currentElementChanged", this.onCurrentElementChanged, this.board);

		//this.on("photo-extracted", this._onPhotoExtractedFinished, fx.service("MediasUploader").photoExtractor);

		this.on("order", this._onOrder, this.topBar);
        this.on("exit", this._onExit, this.topBar);

		// the creation is undeleted on the first modification, not on the opening of the editor
		this.data.undeleteOnFirstUpdate();

        this.data.addPhotosForCreation();    

        this.data.history.start();
    }


	show(callback)
	{
		super.show(callback);
		
        fx.set("mode", "edition");
	}

    _onScroll()
	{
		if (this.productLabel && this.board)
			this.productLabel.toggle(this.board.scrollTop <= 30 && this.data.zoom.value == 100);
	}

    _onOrder()
    {
        this.data.event("order");
    }

    _onExit()
    {
        this.data.event("exit-editor");
    }
	
	enable()
	{
		super.enable();
        if (this.board)
		    this.board.enable();
	}

	disable()
	{
		super.disable();
        if (this.board)
		    this.board.disable();
	}

	onCurrentAreaChanged(e)
	{
		if (this.mediaTabs)
			this.mediaTabs.currentArea = e.detail;
	}

	onCurrentElementChanged(e)
	{
		// nothing to do
	}

	onDataEvent(e)
	{
		switch(e.type)
		{
			case "share-upload-started":
				this.popup(new shared.popups.SharedPhotosPopup(this.data));
				break;

			case "switch-photoPanel":
                if (this.mediaTabs)
				    this.mediaTabs.tabs.selectTab(this.mediaTabs.photoPanel);
				break;

			case "share-upload-validated":
                if (this.mediaTabs)
				    this.mediaTabs.selectFilter(0);
				break;

			case "currentAreaChanged" :
				this.onCurrentAreaChanged(e);
				break;

			case "custom-layout-creating" :
            	this.loading(true, fx.text("Sauvegarde de votre mise en page ..."));
				break;

			case "custom-layout-created" :
                if (this.mediaTabs)
				    this.mediaTabs.tabs.selectTab(this.mediaTabs.layoutPanel);
				this.loading(false);
				break;

			case "custom-layout-error" :
				this.loading(false);
				break;
		}
	}

});